import * as React from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import "./customCarousel.scss"; // Custom styles if needed

export default function CustomCarousel({
  children,
  _itemsPerPage = 3,
  previousButtonClassName = "xl:-left-[46px] lg:-left-[46px] -left-[14px] translate-x-1/2",
  nextButtonClassName = "xl:-right-[15px] lg:-right-[21px] -right-[2px] translate-x-1/2",
}) {
  void _itemsPerPage;
  // itemsPerPage is kept for API compatibility but not used in fit-content implementation
  // In the future, this could be used for setting max-width constraints on larger screens

  // // Effect to update itemsToShow based on screen width
  // React.useEffect(() => {
  //     const updateItemsToShow = () => {
  //         if (window.innerWidth <= 480) {
  //             setItemsToShow(1); // Show 1 item on mobile
  //         } else if (window.innerWidth <= 1024) {
  //             setItemsToShow(itemsPerPage - 2); // Show fewer items on tablet
  //         } else {
  //             setItemsToShow(itemsPerPage); // Default items for desktop
  //         }
  //     };

  //     window.addEventListener('resize', updateItemsToShow);
  //     updateItemsToShow(); // Call once to set initial value

  //     return () => {
  //         window.removeEventListener('resize', updateItemsToShow);
  //     };
  // }, [itemsPerPage]);

  return (
    <div className="relative w-full max-w-full">
      <Carousel
        className="w-full relative"
        opts={{
          align: "start",
          loop: true,
          direction: "ltr",
          containScroll: "trimSnaps",
          slidesToScroll: 1,
          dragFree: false,
          skipSnaps: false,
          inViewThreshold: 0.7,
        }}
      >
        <CarouselContent className="-ml-4 sm:-ml-6">
          {React.Children.map(children, (child, index) => {
            return (
              <CarouselItem
                key={index}
                className={`pl-4 sm:pl-6 flex-shrink-0 basis-auto flex justify-center`}
                style={{
                  minWidth: "280px",
                  maxWidth: "400px",
                }}
              >
                <div className="w-full h-full flex justify-center">{child}</div>
              </CarouselItem>
            );
          })}
        </CarouselContent>

        {children?.length > 1 && (
          <>
            <CarouselPrevious className={previousButtonClassName} />
            <CarouselNext className={nextButtonClassName} />
          </>
        )}
      </Carousel>
    </div>
  );
}
